import { action, makeObservable, observable } from 'mobx';
import { DefaultQueryParams, parseQuery } from '@pascal/pascal-core';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';

import { doBetStore } from './doBetStore';
import { winningStore } from './winningStore';
import { autoBetStore } from './autoBetStore';
import { MIN_ODD } from '../enums/constants';

class GameStore {
  isBetsClosed = false;

  gameTypeId = null;

  isOpenNumPad = false;

  numPadOdd = null;

  pastRoundsData = [];

  pastRoundsDemoData = [];

  isTurboModeExist = false;

  doBetDelay = 0;

  isFreeBetActivatedFromToggle = false;

  constructor() {
    makeObservable(this, {
      gameTypeId: observable,
      isBetsClosed: observable,
      isOpenNumPad: observable,
      numPadOdd: observable,
      isTurboModeExist: observable,
      doBetDelay: observable,
      isFreeBetActivatedFromToggle: observable,
      pastRoundsData: observable.deep,
      pastRoundsDemoData: observable.deep,
      setNumPadOdd: action.bound,
      setGameTypeId: action.bound,
      updatedPastRoundsData: action.bound,
      updatedPastRoundsDemoData: action.bound,
      resetGameState: action.bound,
      setIsBetsClosed: action.bound,
      setIsOpenNumPad: action.bound,
      setIsTurboModeExist: action.bound,
      setDoBetDelay: action.bound,
      setIsFreeBetActivatedFromToggle: action.bound,
    });
  }

  setIsBetsClosed(arg) {
    this.isBetsClosed = arg;
  }

  setGameTypeId() {
    const { [DefaultQueryParams.GameTypeId]: gameTypeId } = parseQuery(window.location.search);
    this.gameTypeId = gameTypeId;
  }

  setNumPadOdd(odd) {
    this.numPadOdd = odd;
  }

  setIsOpenNumPad(boolean) {
    this.isOpenNumPad = boolean;
  }

  updatedPastRoundsData(roundData) {
    const { userId } = userInfoStore;

    if (roundData.userId === +userId) {
      const newPastRoundsData = [roundData, ...this.pastRoundsData];
      this.pastRoundsData =
        newPastRoundsData.length >= 6 ? newPastRoundsData.slice(0, 6) : newPastRoundsData;
    }
  }

  updatedPastRoundsDemoData(roundResult) {
    const newPastRoundsDemoData = [roundResult, ...this.pastRoundsDemoData];
    this.pastRoundsDemoData =
      newPastRoundsDemoData.length >= 6 ? newPastRoundsDemoData.slice(0, 6) : newPastRoundsDemoData;
  }

  resetGameState() {
    const { quickBets } = doBetStore;
    const { limits } = gameConfigStore;
    this.setIsBetsClosed(false);
    winningStore.setLastWin(0);
    doBetStore.setSelectedAmount(limits?.defaultBetAmount || [...quickBets].reverse()[0]);
    doBetStore.setSelectedOdd(MIN_ODD);
    autoBetStore.resetAutoBet();
  }

  setIsTurboModeExist(value) {
    this.isTurboModeExist = value;
  }

  setDoBetDelay(value) {
    this.doBetDelay = value;
  }

  setIsFreeBetActivatedFromToggle(value) {
    this.isFreeBetActivatedFromToggle = value;
  }
}

export const gameStore = new GameStore();
